import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { FormattedMessage } from "react-intl";

import { OrderSessionButtonProps } from "./types";

const OrderSessionButton: React.FC<OrderSessionButtonProps> = ({
  isExpired,
  expireIn,
  onReset,
}) => (
  <Button
    $fullW
    type="button"
    $mode="primary"
    size="large"
    disabled={!isExpired}
    onClick={onReset}
  >
    {isExpired ? (
      <FormattedMessage defaultMessage="Start new Session" />
    ) : (
      <FormattedMessage
        defaultMessage="{value, date, ::mm:ss} Remaining"
        values={{ value: expireIn }}
      />
    )}
  </Button>
);

export default OrderSessionButton;
